module.exports = __webpack_public_path__ + "img/line_zwjwnh.c3b991a7.svg";